<script setup>
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
import { getContactDetailsAPI, addSubscribeAPI } from '@/apis/user'
import router from '@/router';
onMounted(() => {
    getContactDetails()
})
const dialogVisible = ref(false)
const form = reactive({
    formData: {
        whatsApp: "",
        telegram: "",
        email: ""
    },
    contactData: {
        fb: "",
        ins: "",
        telegram: "",
        tk: "",
        watchapp: "",
        youtube: "",

    }
})
const checkOneField = (rule, value, callback) => {
    if (!form.formData.whatsApp && !form.formData.telegram && !form.formData.email) {
        callback(new Error(t('setup62')));
    } else {
        callback();
    }
}
const rules = {
    whatsApp: [
        { validator: checkOneField, trigger: 'blur' }
    ],
    telegram: [
        { validator: checkOneField, trigger: 'blur' }
    ],
    email: [
        { validator: checkOneField, trigger: 'blur' },
        {
            type: 'email',
            message: t('login21'),
            trigger: 'blur,change'
        }
    ]


}
const openTermsOfService = (url) => {
    window.open(url, '_blank');
}
const setSubscribe = () => {
    dialogVisible.value = true
}
const handleClose = () => {
    dialogVisible.value = false
}
/**
 * 获取联系方式
 */
const getContactDetails = async () => {
    const res = await getContactDetailsAPI()
    if (res.code == 0) {
        form.contactData = res.data.data[0]

    }

}
const formRef = ref()
const submit = () => {
    formRef.value.validate(async (valid) => {
        if (valid) {
            const res = await addSubscribeAPI(form.formData)
            if (res.code == 0) {
                dialogVisible.value = false
                ElMessage({ type: 'success', message: t('cart73') });
            }
        }
    });
}

</script>
<template>
    <footer class="app_footer">

        <!-- 其它 -->
        <div class="extra">
            <div class="container">
                <div class="slogan">
                    <a href="javascript:;">
                        <i class="iconfont icon-footer01"></i>
                        <div>{{ $t("home16") }}</div>
                    </a>
                    <a href="javascript:;">
                        <i class="iconfont icon-footer02"></i>
                        <div>{{ $t("home17") }}</div>
                    </a>
                    <a href="javascript:;">
                        <i class="iconfont icon-footer03"></i>
                        <div>{{ $t("home18") }}</div>
                    </a>
                </div>
                <!-- 版权信息 -->
                <div class="copyright">
                    <div class="menu-footer-container">
                        <div class="flex">
                            <div class="sub-menu">
                                {{ $t('setup130') }}
                                <div class="sub-item">
                                    <!-- <p @click="openTermsOfService('/aboutUs')">{{ $t('setup130') }}</p> -->
                                    <p @click="openTermsOfService('/webinfo/aboutUs')">{{ $t('setup130') }}</p>
                                    <p @click="setSubscribe()">{{ $t('setup65') }}</p>
                                </div>
                            </div>
                            <div class="sub-menu">
                                {{ $t('setup131') }}
                                <div class="sub-item">
                                    <p @click="openTermsOfService('/webinfo/ShippingPolicy')">{{ $t('setup133') }}</p>
                                    <p @click="openTermsOfService('/webinfo/pack')">{{ $t('setup134') }}</p>
                                </div>
                            </div>

                            <div class="sub-menu">{{ $t('setup66') }}
                                <div class="sub-item">
                                    <p v-if="form.contactData.watchapp">whatsApp：<a :href="form.contactData.watchapp"
                                            target="_blank">{{ form.contactData.watchapp }}</a></p>
                                    <p v-if="form.contactData.telegram">telegram：<a :href="form.contactData.telegram"
                                            target="_blank">{{ form.contactData.telegram }}</a></p>
                                </div>
                            </div>
                            <div class="sub-menu">
                                {{ $t('setup132') }}
                                <div class="sub-item">
                                    <div class="flex55">
                                        <p 
                                            @click="openTermsOfService('/webinfo/termsOfService')">{{ $t('setup135') }}
                                        </p>
                                        <p
                                            @click="openTermsOfService('/webinfo/returnPolicy')">{{ $t('setup137') }}
                                        </p>
                                    </div>
                                    <div class="flex55">
                                        <p  @click="openTermsOfService('/webinfo/paymentMethods')">{{ $t('setup136') }}
                                        </p>
                                        
                                        <p @click="openTermsOfService('/webinfo/privacyPolicy')">{{ $t('setup138') }}
                                        </p>
                                    </div>
                                    <div class="flex55">
                                        <p  @click="openTermsOfService('/webinfo/intellectualPropertyRights')">{{ $t('setup628') }}
                                        </p>
<!--                                         
                                        <p><img src="https://www.9-bill.com/index/legal">
                                        </p> -->
                                    </div>

                                    <!-- <p>{{ $t('setup68') }}</p> -->
                                </div>
                            </div>
                        </div>
                        <div class="sub-menu no-flex">
                            <div class="flex">
                                <div> {{ $t('setup63') }}</div>
                            </div>

                            <div class="sub-item">
                                <div class="flex46">
                                    <p>{{ $t('setup432') }}alin19991207@51shopy.com</p>
                                    <p v-if="form.contactData.telegram">telegram： <a :href="form.contactData.telegram"
                                            target="_blank">{{ form.contactData.telegram }}</a></p>

                                </div>
                                <!-- <div class="flex46">
                                    <p>{{ $t('setup433') }}</p>
                                    <p v-if="form.contactData.tk">tiktok： <a :href="form.contactData.tk"
                                            target="_blank">{{ form.contactData.tk }}</a></p>
                                </div> -->
                                <div class="flex46">
                                    <p v-if="form.contactData.watchapp">whatsApp： <a :href="form.contactData.watchapp"
                                            target="_blank">{{ form.contactData.watchapp }}</a></p>
                                            <p v-if="form.contactData.tk">tiktok： <a :href="form.contactData.tk"
                                                target="_blank">{{ form.contactData.tk }}</a></p>
                                    <!-- <p>{{ $t('setup434') }}</p> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        {{ $t('setup435') }}

                        <div class="footerimg">
                            
                            <img src="../../../assets/images/log1.png" class="ems" alt="" >
                            <img src="../../../assets/images/log2.png" class="ems" alt="" >
                            <img src="../../../assets/images/Payment6.png" alt="" >
                            <img src="../../../assets/images/Payment1.png" alt="">

                            <img src="../../../assets/images/Payment5.png" alt="">
                            <img src="../../../assets/images/Payment3.png" alt="">
                            <img src="../../../assets/images/Payment2.png" alt="">
                            <img src="../../../assets/images/Payment4.png" alt="">
                            <img src="../../../assets/images/log4.png" class="ems" alt="" >
                            <img src="../../../assets/images/log3.png" class="ems" alt="" >

                        </div>
                    </div>
                    <!-- <p>CopyRight © 51shopy</p> -->
                </div>
            </div>
        </div>
        <el-dialog v-model="dialogVisible" :title="t('setup65')" width="500" :before-close="handleClose">
            <el-form ref="formRef" :model="form.formData" :rules="rules" label-width="auto" style="max-width: 600px">
                <el-form-item :label="t('login7')" prop="email">
                    <el-input v-model="form.formData.email" />
                </el-form-item>
                <el-form-item label="telegram" prop="telegram">
                    <el-input v-model="form.formData.telegram" />
                </el-form-item>
                <el-form-item label="watchApp" prop="whatsApp">
                    <el-input v-model="form.formData.whatsApp" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogVisible = false">{{ $t('home5') }}</el-button>
                    <el-button type="primary" @click="submit()">
                        {{ $t('login15') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </footer>
</template>

<style scoped lang='scss'>
.app_footer {
    // position: fixed;
    // bottom: 0;
    width: 100%;
    // overflow: hidden;
    background-color: #f5f5f5;

    // padding-top: 20px;
    .contact {
        background: #fff;

        .container {
            padding: 60px 0 40px 25px;
            display: flex;
        }

        dl {
            height: 190px;
            text-align: center;
            padding: 0 72px;
            border-right: 1px solid #f2f2f2;
            color: #999;

            &:first-child {
                padding-left: 0;
            }

            &:last-child {
                border-right: none;
                padding-right: 0;
            }
        }

        dt {
            line-height: 1;
            font-size: 18px;
        }

        dd {
            margin: 36px 12px 0 0;
            float: left;
            width: 92px;
            height: 92px;
            padding-top: 10px;
            border: 1px solid #ededed;

            .iconfont {
                font-size: 36px;
                display: block;
                color: #666;
            }

            &:hover {
                .iconfont {
                    color: $xtxColor;
                }
            }

            &:last-child {
                margin-right: 0;
            }
        }

        .qrcode {
            width: 92px;
            height: 92px;
            padding: 7px;
            border: 1px solid #ededed;
        }

        .download {
            padding-top: 5px;
            font-size: 14px;
            width: auto;
            height: auto;
            border: none;

            span {
                display: block;
            }

            a {
                display: block;
                line-height: 1;
                padding: 10px 25px;
                margin-top: 5px;
                color: #fff;
                border-radius: 2px;
                background-color: $xtxColor;
            }
        }

        .hotline {
            padding-top: 20px;
            font-size: 22px;
            color: #666;
            width: auto;
            height: auto;
            border: none;

            small {
                display: block;
                font-size: 15px;
                color: #999;
            }
        }
    }

    .extra {
        background-color: #11192D;
    }

    .slogan {
        height: 188px;
        // line-height: 58px;
        padding: 34px 100px 40px;
        border-bottom: 1px solid #434343;
        display: flex;
        justify-content: space-between;

        a {
            // height: 58px;
            // line-height: 58px;
            color: #fff;
            font-size: 28px;
            display: flex;
            flex-direction: column;
            justify-items: center;
            align-items: center;
            i {
                font-size: 50px;
                vertical-align: middle;
                margin-right: 10px;
                font-weight: 100;
            }

            div {
                vertical-align: middle;
                text-shadow: 0 0 1px #333;
            }
        }
    }

    .copyright {
        height: 480px;
        padding-top: 40px;
        text-align: center;
        color: #999;
        font-size: 15px;

        .menu-footer-container {
            // display: flex;
            // justify-content: space-between;
            color: #FFF;
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 24px;
            line-height: 16px;
            border-bottom: 1px solid #434343;

            >div {
                .sub-menu {
                    text-align: left;

                    
                }
            }

            .flex {
                display: flex;
                justify-content: space-between;
            }
            .flex46 {
                display: flex;
                justify-content: space-between;
                >p:first-child{
                    text-align: left;
                    width: 40%;
                }
                >p:last-child{
                    text-align: left;
                    width: 60%;
                }
            }
            .flex55{
                display: flex;
                justify-content: space-between;
                min-width: 300px;
                >p{
                    text-align: left;
                    width: calc(50% - 10px);

                }
            }

            .no-flex {
                display: block;
            }
            .sub-item {
                padding-top: 24px;
                padding-bottom: 24px;
                cursor: pointer;

                        p {
                            font-size: 14px;
                            color: #ACACAC;
                            line-height: 14px;
                            margin-bottom: 16px;

                        }

                    }

        }

        p {
            line-height: 1;
            margin-bottom: 20px;
        }

        a {
            color: #999;
            line-height: 1;
            padding: 0 10px;
            border-right: 1px solid #999;

            &:last-child {
                border-right: none;
            }
        }

        .footerimg {
            padding: 20px 0 20px 0;

            img {
                width: 80px;
                border-radius: 4px;
                height:50px;
                margin: 0 5px;
            }
            .ems{
                width: 44px; height: 30px;margin:10px 18px;
            }
        }
    }
}
</style>